<template>
    <v-container>
        <v-card style="margin-bottom:10px">
            <v-card-title>
                {{$t('smsSystem')}}
                <v-spacer></v-spacer>
                <v-dialog v-model="sendsms" width="500">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" v-bind="attrs" v-on="on" outlined>
                            <v-icon small>mdi-pencil</v-icon>{{$t('sendNewSms')}}
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            {{$t('sendNewSms')}}
                        </v-card-title>
                        <v-card-text>
                            <v-text-field v-model="phone" :label="$t('phoneNumber')"
                                hint="ניתן לשלוח לכמה מספרי טלפון כאשר בין כל מספר מפריד ,"></v-text-field>
                            <v-text-field v-model="from" :label="$t('callerId')"
                                hint="בחירת מחדל זיהוי המערכת הראשי. ניתן לכתוב מספר מאושר במערכת או מספר משני.">
                            </v-text-field>
                            <v-textarea v-model="message" :label="$t('message')"></v-textarea>
                            {{ status }}
                            <br>
                            {{ statusData }}
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="sendSms">{{$t('sendMessage')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-title>
        </v-card>
        <v-data-table :headers="headers" :items="rows" :items-per-page="-1" class="elevation-1"></v-data-table>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: () => ({
        sendsms: false,
        phone: '',
        from: '',
        message: '',
        status: '',
        statusData: '',
        rows: [

        ],
    }),
    computed: {
        headers () {
            return [
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id'
                },
                { text: this.$t('callerId'), value: 'CallerId' },
                { text: this.$t('target'), value: 'To' },
                { text: this.$t('message'), value: 'Message' },
                { text: this.$t('price'), value: 'Billing' },
                { text: this.$t('whoAction'), value: 'RunBy' },
                { text: this.$t('sentTime'), value: 'Time' },
                { text: this.$t('deliveryReport'), value: 'DeliveryReport' },
            ]
        }
    },
    methods: {
        loadData () {
            (async () => {
                const body = { token: sessionStorage.token};
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetSmsOutLog`, body);
                if (response.data.rows === null) {
                    console.log("לא נמצאו נתונים");
                } else {
                    this.rows = response.data.rows;
                    const DeliveryReportType = {
                        DELIVRD: this.$t('deliverd'),
                        UNDELIV: this.$t('undeliverd'),
                        ESME_ROK: this.$t('transferredToSendSuccess'),
                        EXPIRED: "פג תוקף מעקב המסירה",
                        ESME_RINVDSTADR: "יעד לא נגיש",
                        ESME_RINVMSGLEN: "אורך לא חוקי",
                        ESME_RINVCMDLEN: "אורך פקודה שגוי",
                        ESME_RMSGQFUL: "תור ההודעות מלא",
                        ESME_RINVNUMDESTS: "מספר יעדים לא חוקי",
                        null: "לא התקבל מידע על מסירת ההודעה",
                    }
                    for (let item of this.rows) {
                        item.DeliveryReport = DeliveryReportType[item.DeliveryReport] || item.DeliveryReport;
                    }
                }
            })(); 
        },
        sendSms() {
            (async () => {
                const phones = this.phone.replace(',', ':')
                const body = { token: sessionStorage.token, from: this.from, message: this.message, phones: phones};
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/SendSms`, body);
                if (response.data.responseStatus === "ok") {
                    this.status = this.$t('msgSentSuccess')
                    this.statusData = `${this.$t('msgInfo')}: ${this.$t('callerId')}: ${response.data.from}. ${this.$t('numbers')}: ${response.data.oks}. ${this.$t('message')}: ${response.data.message}. ${this.$t('price')}: ${response.data.Billing}. ${this.$t('errors')}: ${response.data.errors}`
                }
                else if (response.data.responseStatus === "Exception") {
                    this.status = this.$t('error')
                    this.statusData = response.data.message;
                }
                else if (response.data.responseStatus === "ERROR") {
                    this.status = this.$t('error')
                    this.statusData = response.data.message + response.data.errors;
                }
            })();
        },
    },
    beforeMount() {
        this.loadData();
    },
}
</script>